import { TablePageLayout, DataTableExRef } from '@kirz/mui-admin';
import React, { useRef } from 'react';

import { ClientsTable } from 'components/ClientsTable';

export function Clients() {
  const tableRef = useRef<DataTableExRef>(null);

  return (
    <TablePageLayout title="Клиенты">
      <ClientsTable
        id="clients-table"
        ref={tableRef}
        searchFilter={{
          inputProps: {
            placeholder: 'Поиск по ID клиента',
          },
          filter: (search) => ({
            _or: search.flatMap((str) => [
              ...(parseInt(str, 10)
                ? [{ id: { _eq: parseInt(str, 10) } }]
                : []),
            ]),
          }),
        }}
      />
    </TablePageLayout>
  );
}
